import { useState, useEffect, useRef, useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { useFavorites } from '../hooks/useFavorites';
import AuthModal from './AuthModal';
import './AuthModal.css';
import './Header.css';

// Iconos
const logoWhite = "/logo-blanco.svg";
const searchIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'/%3E%3C/svg%3E";
const searchIconDark = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='%23679509' stroke-width='2.5' stroke-linecap='round'%3E%3Ccircle cx='11' cy='11' r='8'/%3E%3Cline x1='21' y1='21' x2='16.65' y2='16.65'/%3E%3C/svg%3E";
const userIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round'%3E%3Cpath d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2'/%3E%3Ccircle cx='12' cy='7' r='4'/%3E%3C/svg%3E";
const ticketsIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2' stroke-linecap='round'%3E%3Cpath d='M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z'/%3E%3Cpath d='M13 5v2m0 4v2m0 4v2'/%3E%3C/svg%3E";
const categoriesIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='%23ccc' stroke-width='2' stroke-linecap='round'%3E%3Cpath d='M4 6h16M4 12h16M4 18h16'/%3E%3C/svg%3E";
const helpIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='%23ccc' stroke-width='2' stroke-linecap='round'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3'/%3E%3Cline x1='12' y1='17' x2='12.01' y2='17'/%3E%3C/svg%3E";
const ordersIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23ccc' stroke-width='2' stroke-linecap='round'%3E%3Cpath d='M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z'/%3E%3C/svg%3E";
const menuIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='18' height='12'%3E%3Cpath d='M128 102.4c0-14.138 11.462-25.6 25.6-25.6h332.8c14.138 0 25.6 11.462 25.6 25.6S500.538 128 486.4 128H153.6c-14.138 0-25.6-11.463-25.6-25.6zm358.4 128H25.6C11.462 230.4 0 241.863 0 256c0 14.138 11.462 25.6 25.6 25.6h460.8c14.138 0 25.6-11.462 25.6-25.6 0-14.137-11.462-25.6-25.6-25.6zm0 153.6H256c-14.137 0-25.6 11.462-25.6 25.6 0 14.137 11.463 25.6 25.6 25.6h230.4c14.138 0 25.6-11.463 25.6-25.6 0-14.138-11.462-25.6-25.6-25.6z' fill='%23ffffff'/%3E%3C/svg%3E";
const closeIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2.5' stroke-linecap='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'/%3E%3Cline x1='6' y1='6' x2='18' y2='18'/%3E%3C/svg%3E";
const closeIconDark = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='%23494553' stroke-width='2.5' stroke-linecap='round'%3E%3Cline x1='18' y1='6' x2='6' y2='18'/%3E%3Cline x1='6' y1='6' x2='18' y2='18'/%3E%3C/svg%3E";

function useDebounce(value, delay) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);
  return debounced;
}

function SearchResults({ results, loading, query, onClose }) {
  if (!query || query.length < 2) return null;
  return (
    <div className="busqueda-resultados">
      {loading ? (
        <div className="busqueda-resultados__loading">Buscando...</div>
      ) : results.length === 0 ? (
        <div className="busqueda-resultados__vacio">No se encontraron ofertas para "{query}"</div>
      ) : (
        results.map(o => (
          <a key={o.id} href={`/ofertas/${o.slug}`} className="busqueda-resultado" onClick={onClose}>
            <div className="busqueda-resultado__img">
              {o.imagen_principal ? (
                <img src={o.imagen_principal} alt="" />
              ) : (
                <div className="busqueda-resultado__img-placeholder" />
              )}
            </div>
            <div className="busqueda-resultado__info">
              <h4 className="busqueda-resultado__titulo">{o.titulo}</h4>
              <div className="busqueda-resultado__meta">
                {o.comercio?.nombre_comercial && <span>{o.comercio.nombre_comercial}</span>}
                {o.ciudad?.nombre && <span>• {o.ciudad.nombre}</span>}
              </div>
              {o.categoria?.nombre && <span className="busqueda-resultado__cat">{o.categoria.nombre}</span>}
            </div>
          </a>
        ))
      )}
    </div>
  );
}

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [favoritosOpen, setFavoritosOpen] = useState(false);
  const { favorites, removeFavorite, count: favCount } = useFavorites();
  const [searchOpen, setSearchOpen] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [userPanelOpen, setUserPanelOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('auth_user') || 'null'); } catch { return null; }
  });
  const isLoggedIn = !!localStorage.getItem('auth_token');

  const [searchQuery, setSearchQuery] = useState('');
  const debouncedQuery = useDebounce(searchQuery, 200);
  const searchInputRef = useRef(null);
  const mobileSearchRef = useRef(null);
  const searchWrapRef = useRef(null);

  // Categorias dinamicas para la navegacion
  const { data: categoriasData } = useQuery({
    queryKey: ['headerCategorias'],
    queryFn: async () => {
      const res = await fetch('/api/categorias').then(r => r.json());
      return res.exito || res.datos ? (res.datos || []) : [];
    },
    staleTime: 600000,
  });
  const categorias = (categoriasData || []).slice(0, 6);

  const { data: searchData, isFetching: searchLoading } = useQuery({
    queryKey: ['headerSearch', debouncedQuery],
    queryFn: async () => {
      const res = await fetch(`/api/buscar?q=${encodeURIComponent(debouncedQuery)}`).then(r => r.json());
      return res.exito ? res.datos : [];
    },
    enabled: debouncedQuery.length >= 2,
    staleTime: 60000,
  });
  const searchResults = (debouncedQuery.length >= 2) ? (searchData || []) : [];

  useEffect(() => {
    function handleClick(e) {
      if (searchWrapRef.current && !searchWrapRef.current.contains(e.target)) {
        setSearchQuery('');
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useEffect(() => {
    if (searchOpen && mobileSearchRef.current) {
      setTimeout(() => mobileSearchRef.current.focus(), 100);
    }
  }, [searchOpen]);

  const closeSearch = useCallback(() => {
    setSearchQuery('');
    setSearchOpen(false);
  }, []);

  const handleAccountClick = () => {
    if (isLoggedIn && currentUser) {
      setUserPanelOpen(true);
      const token = localStorage.getItem('auth_token');
      fetch('/api/auth/profile', { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.json())
        .then(data => {
          const user = data.usuario || data.user || data;
          if (user && user.id) {
            localStorage.setItem('auth_user', JSON.stringify(user));
            setCurrentUser(user);
          }
        })
        .catch(() => {});
    } else {
      setAuthModalOpen(true);
    }
  };

  const { data: profileData } = useQuery({
    queryKey: ['headerProfile'],
    queryFn: async () => {
      const token = localStorage.getItem('auth_token');
      if (!token) throw new Error('No token');
      const r = await fetch('/api/auth/profile', { headers: { Authorization: `Bearer ${token}` } });
      if (!r.ok) throw new Error('Profile failed');
      return r.json();
    },
    enabled: isLoggedIn,
    staleTime: 300000,
  });

  useEffect(() => {
    if (profileData) {
      const user = profileData.usuario || profileData.user || profileData;
      if (user && user.id) {
        localStorage.setItem('auth_user', JSON.stringify(user));
        setCurrentUser(user);
      }
    }
  }, [profileData]);

  useEffect(() => {
    const onOpenFavs = () => setFavoritosOpen(true);
    const onOpenProfile = () => handleAccountClick();
    window.addEventListener('open-favorites', onOpenFavs);
    window.addEventListener('open-profile', onOpenProfile);
    return () => {
      window.removeEventListener('open-favorites', onOpenFavs);
      window.removeEventListener('open-profile', onOpenProfile);
    };
  }, [isLoggedIn, currentUser]);

  const handleAuthSuccess = (user) => setCurrentUser(user);

  const handleLogout = async () => {
    const token = localStorage.getItem('auth_token');
    try {
      if (token) await fetch('/api/auth/logout', { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
    } catch {}
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    setCurrentUser(null);
    setUserPanelOpen(false);
  };

  // Ofertas favoritas (lazy)
  const favKey = JSON.stringify(favorites);
  const { data: favOfertasData } = useQuery({
    queryKey: ['headerFavOfertas', favKey],
    queryFn: async () => {
      const res = await fetch('/api/ofertas?per_page=100').then(r => r.json());
      if (res.exito) {
        const all = res.datos.data || res.datos || [];
        return all.filter(o => favorites.includes(o.id));
      }
      return [];
    },
    enabled: favoritosOpen && favorites.length > 0,
    staleTime: 60000,
  });
  const favOfertas = favOfertasData || [];

  return (
    <header className="encabezado">
      <div className="nav-principal">
        <div className="nav-principal__container">
          <a href="/" className="nav-principal__logo">
            <img src={logoWhite} alt="Cuponeo" />
          </a>

          {/* Buscador escritorio */}
          <div className="barra-busqueda" ref={searchWrapRef}>
            <div className="barra-busqueda__category">
              <span>Todas las categorias</span>
            </div>
            <div className="barra-busqueda__input-wrap">
              <input
                ref={searchInputRef}
                className="barra-busqueda__input"
                type="text"
                placeholder="Busca restaurantes, spa, viajes, cursos..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="barra-busqueda__btn" onClick={() => searchInputRef.current?.focus()}>
              <img src={searchIcon} alt="Buscar" />
            </div>
            <SearchResults results={searchResults} loading={searchLoading} query={debouncedQuery} onClose={closeSearch} />
          </div>

          {/* Cuenta escritorio */}
          <div className="area-cuenta">
            {isLoggedIn && currentUser ? (
              <>
                {currentUser.photo_url ? (
                  <img className="area-cuenta__user-icon" src={currentUser.photo_url}
                    alt="" style={{ width: 28, height: 28, borderRadius: '50%', objectFit: 'cover', border: '2px solid rgba(255,255,255,0.4)' }} />
                ) : (
                  <div style={{ width: 28, height: 28, borderRadius: '50%', background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', fontWeight: 700, color: '#fff' }}>
                    {currentUser.name?.charAt(0).toUpperCase()}
                  </div>
                )}
                <button className="area-cuenta__link" onClick={handleAccountClick}>
                  <span>{currentUser.name?.split(' ')[0]}</span>
                </button>
              </>
            ) : (
              <>
                <img className="area-cuenta__user-icon" src={userIcon} alt="" />
                <button className="area-cuenta__link" onClick={handleAccountClick}>
                  <span>Mi Cuenta</span>
                </button>
              </>
            )}
            <Link to="/mi-cuenta" className="area-cuenta__tickets" style={{ cursor: 'pointer', textDecoration: 'none' }}>
              <img className="area-cuenta__tickets-icon" src={ticketsIcon} alt="" />
              <span className="area-cuenta__link">Mis Cupones</span>
            </Link>
          </div>

          {/* Iconos movil */}
          <div className="iconos-movil">
            <button className="iconos-movil__btn" aria-label="Buscar" onClick={() => setSearchOpen(true)}>
              <img src={searchIcon} alt="Buscar" />
            </button>
            <button className="iconos-movil__btn" aria-label="Mi cuenta" onClick={handleAccountClick}>
              {isLoggedIn && currentUser?.photo_url ? (
                <img src={currentUser.photo_url} alt="" style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover' }} />
              ) : (
                <img src={userIcon} alt="Mi cuenta" />
              )}
            </button>
            <button className="iconos-movil__btn" aria-label="Menu" onClick={() => setMenuOpen(true)}>
              <img src={menuIcon} alt="Menu" />
            </button>
          </div>
        </div>
      </div>

      {/* Navegacion secundaria (escritorio) */}
      <div className="nav-secundaria">
        <div className="nav-secundaria__container">
          <nav className="nav-secundaria__links">
            <Link to="/ofertas" className="nav-secundaria__link secondary-nav__link--bold">
              <img src={categoriesIcon} alt="" width="13.5" height="9" />
              Todas las ofertas
            </Link>
            {categorias.map(c => (
              <Link key={c.id} to={`/categoria/${c.slug}`} className="nav-secundaria__link">{c.nombre}</Link>
            ))}
          </nav>
          <div className="nav-secundaria__right">
            <Link to="/ayuda" className="nav-secundaria__right-link">
              <img src={helpIcon} alt="" width="15" height="15" />
              Centro de Ayuda
            </Link>
            <a href="#" className="nav-secundaria__right-link" onClick={e => { e.preventDefault(); setFavoritosOpen(true); }}>
              <img src={ordersIcon} alt="" width="16.5" height="12" />
              Mis Favoritos
              {favCount > 0 && <span className="nav-secundaria__badge">{favCount}</span>}
            </a>
          </div>
        </div>
      </div>

      {/* Buscador movil */}
      <div className={`busqueda-movil ${searchOpen ? 'busqueda-movil--abierto' : ''}`}>
        <div className="busqueda-movil__cabecera">
          <div className="busqueda-movil__input-wrap">
            <img src={searchIconDark} alt="" className="busqueda-movil__icono" />
            <input
              ref={mobileSearchRef}
              className="busqueda-movil__input"
              type="text"
              placeholder="Buscar ofertas..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
          </div>
          <button className="busqueda-movil__cerrar" onClick={closeSearch}>
            <img src={closeIconDark} alt="Cerrar" />
          </button>
        </div>
        <div className="busqueda-movil__resultados">
          <SearchResults results={searchResults} loading={searchLoading} query={debouncedQuery} onClose={closeSearch} />
        </div>
      </div>

      {/* Off-canvas: Menu */}
      <div className={`offcanvas ${menuOpen ? 'offcanvas--abierto' : ''}`}>
        <div className="offcanvas__overlay" onClick={() => setMenuOpen(false)} />
        <div className="offcanvas__panel">
          <div className="offcanvas__cabecera">
            <img src={logoWhite} alt="Cuponeo" className="offcanvas__logo" />
            <button className="offcanvas__cerrar" onClick={() => setMenuOpen(false)} aria-label="Cerrar">
              <img src={closeIcon} alt="" />
            </button>
          </div>
          <nav className="offcanvas__nav">
            <span className="offcanvas__seccion-titulo">Categorias</span>
            <Link to="/ofertas" className="offcanvas__enlace" onClick={() => setMenuOpen(false)}>Todas las ofertas</Link>
            {categorias.map(c => (
              <Link key={c.id} to={`/categoria/${c.slug}`} className="offcanvas__enlace" onClick={() => setMenuOpen(false)}>{c.nombre}</Link>
            ))}
          </nav>
          <div className="offcanvas__separador" />
          <nav className="offcanvas__nav">
            <Link to="/mi-cuenta" className="offcanvas__enlace" onClick={() => setMenuOpen(false)}>Mis Cupones</Link>
            <Link to="/ayuda" className="offcanvas__enlace" onClick={() => setMenuOpen(false)}>Centro de Ayuda</Link>
            <a href="#" className="offcanvas__enlace" onClick={() => { setMenuOpen(false); setFavoritosOpen(true); }}>Mis Favoritos{favCount > 0 ? ` (${favCount})` : ''}</a>
          </nav>
          <div className="offcanvas__pie">
            <Link to="/ofertas" className="boton-principal offcanvas__cta" onClick={() => setMenuOpen(false)} style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>Explorar Ofertas</Link>
          </div>
        </div>
      </div>

      {/* Off-canvas: Favoritos */}
      <div className={`offcanvas offcanvas--derecha ${favoritosOpen ? 'offcanvas--abierto' : ''}`}>
        <div className="offcanvas__overlay" onClick={() => setFavoritosOpen(false)} />
        <div className="offcanvas__panel">
          <div className="offcanvas__cabecera">
            <h3 className="offcanvas__titulo">Mis Favoritos</h3>
            <button className="offcanvas__cerrar" onClick={() => setFavoritosOpen(false)} aria-label="Cerrar">
              <img src={closeIcon} alt="" />
            </button>
          </div>
          {favOfertas.length === 0 ? (
            <div className="carrito__vacio">
              <p>No tienes favoritos aun</p>
              <Link to="/ofertas" className="boton-principal" onClick={() => setFavoritosOpen(false)}>Explorar Ofertas</Link>
            </div>
          ) : (
            <div className="carrito__lista">
              {favOfertas.map(o => (
                <div key={o.id} className="carrito__item">
                  {o.imagen_principal && (
                    <img src={o.imagen_principal} alt="" style={{ width: 56, height: 56, borderRadius: '0 12px 0 12px', objectFit: 'cover', flexShrink: 0 }} />
                  )}
                  <div className="carrito__item-info" style={{ flex: 1 }}>
                    <a href={`/ofertas/${o.slug}`} onClick={() => setFavoritosOpen(false)}>
                      <h4 className="carrito__item-titulo">{o.titulo}</h4>
                    </a>
                    <p className="carrito__item-fecha">
                      {o.comercio?.nombre_comercial || ''}{o.ciudad?.nombre ? ` • ${o.ciudad.nombre}` : ''}
                    </p>
                  </div>
                  <button className="carrito__item-eliminar" aria-label="Eliminar" onClick={() => removeFavorite(o.id)}>✕</button>
                </div>
              ))}
            </div>
          )}
          <div className="offcanvas__pie">
            <Link to="/ofertas" className="boton-principal offcanvas__cta" onClick={() => setFavoritosOpen(false)} style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>Seguir Explorando</Link>
          </div>
        </div>
      </div>

      {/* Auth Modal */}
      <AuthModal isOpen={authModalOpen} onClose={() => setAuthModalOpen(false)} onAuth={handleAuthSuccess} />

      {/* Off-canvas: Panel de usuario */}
      <div className={`offcanvas offcanvas--derecha ${userPanelOpen ? 'offcanvas--abierto' : ''}`}>
        <div className="offcanvas__overlay" onClick={() => setUserPanelOpen(false)} />
        <div className="offcanvas__panel">
          <div className="offcanvas__cabecera">
            <h3 className="offcanvas__titulo">Mi Cuenta</h3>
            <button className="offcanvas__cerrar" onClick={() => setUserPanelOpen(false)} aria-label="Cerrar">
              <img src={closeIcon} alt="" />
            </button>
          </div>

          {currentUser && (
            <>
              <div className="user-offcanvas__header">
                {currentUser.photo_url ? (
                  <img className="user-offcanvas__avatar" src={currentUser.photo_url} alt="" />
                ) : (
                  <div className="user-offcanvas__avatar--initials">{currentUser.name?.charAt(0).toUpperCase()}</div>
                )}
                <div>
                  <p className="user-offcanvas__name">{currentUser.name}</p>
                  <p className="user-offcanvas__email">{currentUser.email}</p>
                </div>
              </div>

              <nav className="user-offcanvas__nav">
                <a href="/mi-cuenta" className="user-offcanvas__link" onClick={() => setUserPanelOpen(false)}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                  Mi Perfil
                </a>
                <a href="/mi-cuenta" className="user-offcanvas__link" onClick={() => setUserPanelOpen(false)}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/></svg>
                  Mis Cupones
                </a>
                <a href="#" className="user-offcanvas__link" onClick={(e) => { e.preventDefault(); setUserPanelOpen(false); setFavoritosOpen(true); }}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
                  Mis Favoritos
                  {favCount > 0 && <span style={{ marginLeft: 'auto', background: 'rgba(255,255,255,0.12)', padding: '2px 8px', borderRadius: 10, fontSize: '0.75rem' }}>{favCount}</span>}
                </a>
              </nav>

              <div style={{ marginTop: 12 }}>
                <button className="user-offcanvas__logout" onClick={handleLogout}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                  Cerrar Sesion
                </button>
              </div>

              <div className="offcanvas__pie">
                <a href="/mi-cuenta" className="boton-principal offcanvas__cta" onClick={() => setUserPanelOpen(false)} style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>Ver Mi Cuenta</a>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
